import { WebPlugin } from '@capacitor/core';
export class BrightcovePlayerWeb extends WebPlugin {
    async updateBrightcoveAccount(options) {
        console.log('updateBrightcoveAccount', options);
        return;
    }
    async playVideo(options) {
        console.log('playVideo', options);
        return { name: '', duration: 0 };
    }
    async setSubtitleLanguage(options) {
        console.log('setSubtitleLanguage', options);
        return;
    }
    async loadAudio(options) {
        console.log('loadAudio', options);
        return {};
    }
    async backwardAudio(options) {
        console.log('backwardAudio', options);
        return;
    }
    async forwardAudio(options) {
        console.log('forwardAudio', options);
        return;
    }
    async seekToAudio(options) {
        console.log('seekTo', options);
        return;
    }
    async enableAudioLooping(options) {
        console.log('enable looping', options);
        return;
    }
    async disableAudioLooping() {
        console.log('disable looping');
        return;
    }
    async isAudioLooping() {
        console.log('is looping');
        return { value: false };
    }
    async stopAudio() {
        console.log('stopAudio');
        return;
    }
    async pauseAudio() {
        console.log('pauseAudio');
        return;
    }
    async playAudio() {
        console.log('playAudio');
        return;
    }
    async getVideoPlayerState() {
        console.log('getVideoPlayerState');
        return {};
    }
    async getAudioPlayerState() {
        console.log('getAudioPlayerState');
        return {};
    }
    async destroyAudioPlayer() {
        return;
    }
    async setAudioNotificationOptions(options) {
        console.log('Set audio notification options', options);
        return;
    }
    async isMediaAvailableLocally(options) {
        console.log('Is Media Available Locally', options);
        return { value: false };
    }
    async downloadMedia(options) {
        console.log('Download Media', options);
        return;
    }
    async getDownloadedMediasState() {
        console.log("get Downloaded medias");
        return { medias: [] };
    }
    async deleteDownloadedMedia(options) {
        console.log("Delete downloaded file", options);
        return;
    }
    async notifyBackButtonPressed() {
        console.log('Not implemented');
        return;
    }
    async playInternalAudio(options) {
        console.log('Local internal not implemented ', options);
        return;
    }
    async deleteAllDownloadedMedias() {
        console.log('Delete all downloaded medias');
    }
}
//# sourceMappingURL=web.js.map